import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
  button: {
    '--button-shadow-color': null,

    color: 'white',
    // padding: '10px 20px',
    // padding: 'clamp(0.75rem, -0.875rem + 8.333333vw, 1.25rem);',

    padding: 'clamp(5px, 2vw, 10px) clamp(10px, 2vw, 20px)',

    borderRadius: 6,
    border: '2px solid transparent',
    fontWeight: 'bold',
    cursor: 'pointer',
    // minWidth: 100,
    textAlign: 'center',
    transition: 'box-shadow 0.2s ease-in-out',
    boxShadow: `0 0 3px var(--button-shadow-color)`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    '&:hover': {
      boxShadow: `0 0 9px var(--button-shadow-color)`,
    },
  },

  primary: {
    backgroundColor: 'var(--jmi-blue-light)',
    '--button-shadow-color': 'var(--jmi-blue-light)',
  },
  secondary: {
    backgroundColor: 'var(--jmi-red)',
    '--button-shadow-color': 'var(--jmi-red)',
  },

  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
    backgroundColor: 'lightgray',
    '--button-shadow-color': 'lightgray',
    color: 'black',
  },
});

const SelfInspectButton = withStyles(styles)(
  ({
    //
    classes,
    label,
    onClick,
    primary,
    secondary,
    disabled = false,
    style,
    className,
  }) => {
    const color = secondary ? 'secondary' : 'primary';

    return (
      <div
        //
        className={classnames(
          //
          classes.button,
          classes[color],
          disabled && classes.disabled,
          className,
        )}
        onClick={disabled ? null : onClick}
        style={style}
      >
        {label}
      </div>
    );
  },
);

SelfInspectButton.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

SelfInspectButton.defaultProps = {
  primary: true,
  secondary: false,
  label: 'Button',
  onClick: () => null,
};

export default SelfInspectButton;
